<div class="unsaved-refresh-dialog">
  <div class="d-flex flex-row align-items-center unsaved-refresh-header dialog-gap fw-bold">
    <i class="pi pi-exclamation-triangle fs-4"></i>
    <h5 class="m-0">Unsaved Changes</h5>
  </div>
  <p class="mt-3">Refreshing will load the last save point from Byte/Clear. Any unsaved changes will be lost. Are you sure you want to proceed?</p>
  <div class="dialog-button-container">
    <button pButton severity="secondary" type="button" (click)="cancel()">Cancel</button>
    <button pButton type="button" (click)="refresh()">Refresh</button>
  </div>
</div>
